export var SIZE_WIDTH = {
  sm: 300,
  md: 400,
  lg: 600
};